import React, {Component, PropTypes} from 'react';

// Stores and Actions
import mapStore from '../../stores/map'
import mapActions from '../../actions/map';
import StoreConnect from '../../flux/StoreConnect'

// Subviews
import Spinner from '../spinner';
import Zoomer from '../zoomer';
import MiniMap from '../minimap';
import SvgMap from '../map';
import Tooltip from '../tooltip';
import FatalError from '../fatalerror';

let transitioningTimeout;

class SIMMain extends Component {

  constructor (props) {
    super(props);
    this.state = {transitioning: false};
  }

  // todo, apply animation class, might be better to move in a store
  componentDidMount () {
    mapActions.on(mapActions.EVENTS.SECTION_TOGGLE, this.applyTransitionClass.bind(this));
  }

  componentWillUnmount () {
    mapActions.removeListener(mapActions.EVENTS.SECTION_TOGGLE, this.applyTransitionClass.bind(this));
  }

  applyTransitionClass () {
    this.setState({transitioning: true});

    clearTimeout(transitioningTimeout);
    transitioningTimeout = setTimeout(function () {
      this.setState({transitioning: false});
    }.bind(this), 400);
  }

  render () {
    if (this.props.map.fatalError) {
      return <FatalError />
    }

    if (!this.props.map || !this.props.map.geometry || !this.props.map.geometry.length) {
      return <Spinner />;
    }

    var mainClassName = 'map__wrapper';
    mainClassName += this.state.transitioning ? ' transitioning' : '';

    return (
      <div className={mainClassName}>
        <div className="map" id="map-container">
          <Tooltip />
          <Zoomer>
            <SvgMap />
          </Zoomer>
          <MiniMap>
            <SvgMap static />
          </MiniMap>
        </div>
      </div>
    );
  }
}

// Define schema
SIMMain.propTypes = {
  map: PropTypes.shape({
    fatalError:    PropTypes.bool.isRequired,
    activeSection: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    geometry:      PropTypes.oneOfType([PropTypes.array, PropTypes.bool]).isRequired
  })
};

// Export Component
export default StoreConnect(SIMMain, {map: mapStore});



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/main/index.jsx